<template>
	<!-- The print sheet is hidden on screen and becomes the only visible element
	     when the browser prints: `visibility` (not `display`) is used so the
	     app's layout stays intact on screen, and the sheet is lifted to the
	     page's top-left for the printer. -->
	<div class="print-sheet">
		<slot />
	</div>
</template>

<script setup lang="ts">
// A reusable browser-print sheet: the caller renders the sticker/sheet grid in
// the default slot and calls window.print() from its own button. No props — the
// content is the caller's.
</script>

<style>
.print-sheet {
	display: none;
}

@media print {
	body * {
		visibility: hidden;
	}
	.print-sheet,
	.print-sheet * {
		visibility: visible;
	}
	.print-sheet {
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
	}
}
</style>
